import api from '@shared/services/api';

export const currencyService = {
    getCurrencies: async () => {
        const response = await api.get('/currency');
        return response.data;
    },
    createCurrency: async (currency) => {
        const response = await api.post('/currency', currency);
        return response.data;
    },
    updateCurrency: async (currencyId, currencyData) => {
        const response = await api.put(`/currency/${currencyId}`, currencyData);
        return response.data;
    },
    deleteCurrency: async (currencyId) => {
        const response = await api.delete(`/currency/${currencyId}`);
        return response.data;
    }
};
